export default __webpack_public_path__ + "static/media/pantry1-afterF-1920w.193bd579.webp";